<script>
import Multiselect from 'vue-multiselect'
import FormAudioPlay from '@components/version-1/skills-card-form-audio-play'

import FormSpeechSynthesis from '@components/version-1/skills-card-form-speech-synthesis'
import FormAudioTranscription from '@components/version-1/skills-card-form-audio-transcription'
import FormSetVariables from '@components/version-1/skills-card-form-set-variables'
import FormSMSSend from '@components/version-1/skills-card-form-sms-send'
import FormHTTPRequest from '@components/version-1/skills-card-form-http-request'
import FormCondition from '@components/version-1/skills-card-form-condition'
import FormIntent from '@components/version-1/skills-card-form-intent'
import FormAudioRecord from '@components/version-1/skills-card-form-audio-record'

export default {

    components: {
        Multiselect, FormAudioPlay, FormSpeechSynthesis, FormAudioTranscription,
        FormSetVariables, FormSMSSend, FormHTTPRequest, FormCondition, FormIntent,
        FormAudioRecord
    },

    props: {
        index:    { type: Number },
        params:   { type: Object },
        bot_uuid: { type: String },
        skill_uuid: { type: String }
    },

    data() {
        return {
            trackByAction: 'code',

            id: 0,
            parents_id: [],
            action: null,
            description: null,
            sms_send: {
                phone: null,
                text: null,
                provider: null,
                provider_uuid: null,
                product_code: 'sms_send'
            },
            audio: {
                title: null,
                filename: null,
                status: null,
                path: null,
                ext: null,
                uuid: null,
                from_variable: false,
                source_variable: null,
            },
            record: {
                async_action: false,
                variable_name: null,
                max_silence_begin: null,
                max_silence_end: null,
            },
            stt_params: {
                async_action: false,
                grammar: null,
                language: null,
                provider: null,
                provider_uuid: null,
                product_code: 'stt',
                source_variable: null,
                variable_name: null,
                max_silence_begin: null,
                max_silence_end: null,
                delayed: null,
                delayed_time: null                
            },
            tts_params: {
                ssml: null,
                id: null,
                speed: 1,
                emotion: null,
                language: null,
                provider: null,
                provider_uuid: null,
                product_code: 'tts',
                variable_name: null
            },
            text: null,
            intent: {
                variable: null,
                words_equal: [],
                words_in: [],
                words_not_in: [],
                action: null
            },
            condition: {
                operation: null,
                action: null
            },
            http_request_params: {
                url: null,
                method: null,
                header: null,
                variables: null
            },

            set_variables: null,

            next_action: null,

            initAction: [],
            actions_options: [],

            show_audio_play: false,
            show_speech_synthesis: false,
            show_audio_transcription: false,
            show_set_variables: false,
            show_sms_send: false,
            show_http_request: false,
            show_condition: false,
            show_intent: false,
            show_call: false,
            show_audio_record: false,
            show_end_call: false,

            show_variable_name_item: false,

            attachments: new Map(),
        }
    },

    watch: {
        initAction: {
            immediate: true,
            handler(values) {
                this.action = this.actions_options.filter(x => values.includes(x[this.trackByAction]));
                this.action = this.action[0];
            }
        },

        action: {
            immediate: true,
            handler(values) {

                this.show_audio_play = false;
                this.show_speech_synthesis = false;
                this.show_audio_transcription = false;
                this.show_set_variables = false;
                this.show_sms_send = false;
                this.show_http_request = false;
                this.show_condition = false;
                this.show_intent = false;
                this.call = false;
                this.audio_record = false;
                this.end_call = false;

                if(this.action && this.action.code) {

                    // Проиграть аудио
                    if (this.action.code === 'audio_play') {
                        this.show_audio_play = true;
                    }

                    // Синтезировать голос
                    if (this.action.code === 'speech_synthesis') {
                        this.show_speech_synthesis = true;
                    }

                    // Распознать голос
                    if (this.action.code === 'audio_transcription') {
                        this.show_audio_transcription = true;
                    }

                    // Присвоить переменную
                    if (this.action.code === 'set_variables') {
                        this.show_set_variables = true;
                    }                    

                    // Отправить SMS сообщение
                    if (this.action.code === 'sms_send') {
                        this.show_sms_send = true;
                    }

                    // Выполнить HTTP-запрос
                    if (this.action.code === 'http_request') {
                        this.show_http_request = true;
                    }

                    // Условие
                    if (this.action.code === 'condition') {
                        this.show_condition = true;
                    }

                    // Интент
                    if (this.action.code === 'intent') {
                        this.show_intent = true;
                    }

                    // Позвонить
                    if (this.action.code === 'call') {
                        this.show_call = true;
                    }

                    // Записать разговор
                    if (this.action.code === 'audio_record') {
                        this.show_audio_record = true;
                    }

                    // Завершить звонок
                    if (this.action.code === 'end_call') {
                        this.show_end_call = true;
                    }
                }
            }
        },
    },

    computed: {
        attachments_files: {
            get: function () {
                return this.attachments
            },
            set: function (value) {
                this.attachments = value;
            }
        },

        actions_list_data(){
            return this.$store.getters['actions/GET_ACTIONS_LIST_DATA'];
        },
    },

    async mounted() {

        await this.$store.dispatch('actions/FETCH_ACTIONS_LIST', {});
        this.actions_options = this.actions_list_data;

        this.id = this.params.id;
        this.action = this.params.action ? this.params.action : null;
        if(this.action !== null){
            this.initAction = [this.action]
        }
        this.description = this.params.description ? this.params.description : null;
        this.parents_id = this.params.parents_id ? this.params.parents_id : null;

        this.sms_send = {
            phone: this.params.sms_send.phone ? this.params.sms_send.phone : null,
            text: this.params.sms_send.text ? this.params.sms_send.text : null,
            provider: this.params.sms_send.provider ? this.params.sms_send.provider : null,
            product_code: this.params.sms_send.product_code && this.params.sms_send.product_code !== '' ? this.params.sms_send.product_code : this.sms_send.product_code
        }

        this.audio = {
            title: this.params.audio.title ? this.params.audio.title : null,
            filename: this.params.audio.filename ? this.params.audio.filename : null,
            status: this.params.audio.status ? this.params.audio.status : null,
            path: this.params.audio.path ? this.params.audio.path : null,
            ext: this.params.audio.ext ? this.params.audio.ext : null,
            uuid: this.params.audio.uuid ? this.params.audio.uuid : null,
            from_variable: this.params.audio.from_variable ? this.params.audio.from_variable : false,
            source_variable: this.params.audio.source_variable ? this.params.audio.source_variable : null
        }

        this.record = {
            async_action: this.params.record && this.params.record.async_action ? this.params.record.async_action : null,
            max_silence_begin: this.params.record && this.params.record.max_silence_begin ? this.params.record.max_silence_begin : null,
            max_silence_end: this.params.record && this.params.record.max_silence_end ? this.params.record.max_silence_end : null,
            variable_name: this.params.record && this.params.record.variable_name ? this.params.record.variable_name : null,
        }
        
        let attachments = new Map();
        if(this.audio.filename !== null){
            attachments.set(this.audio.uuid, {
                'title'    : this.audio.title,
                'filename' : this.audio.filename,
                'status'   : this.audio.status,
                'path'     : this.audio.path,
                'ext'      : this.audio.ext,
                'uuid'     : this.audio.uuid
            })
            this.attachments_files = attachments;
        }

        this.stt_params = {
            grammar: this.params.stt_params.grammar ? this.params.stt_params.grammar : null,
            language: this.params.stt_params.language ? this.params.stt_params.language : null,
            provider: this.params.stt_params.provider ? this.params.stt_params.provider : null,
            product_code: this.params.stt_params.product_code && this.params.stt_params.product_code !== '' ? this.params.stt_params.product_code : this.stt_params.product_code,
            variable_name: this.params.stt_params.variable_name ? this.params.stt_params.variable_name : null,
            source_variable: this.params.stt_params.source_variable ? this.params.stt_params.source_variable : null,
            max_silence_begin: this.params.stt_params.max_silence_begin ? this.params.stt_params.max_silence_begin : null,
            max_silence_end: this.params.stt_params.max_silence_end ? this.params.stt_params.max_silence_end : null,
            async_action: this.params.stt_params.async_action ? this.params.stt_params.async_action : null,
            delayed: this.params.stt_params && this.params.stt_params.delayed ? this.params.stt_params.delayed : null,
            delayed_time: this.params.stt_params && this.params.stt_params.delayed_time ? this.params.stt_params.delayed_time : 0
        }

        this.tts_params = {
            ssml: this.params.tts_params.ssml ? this.params.tts_params.ssml : null,
            id: this.params.tts_params.id ? this.params.tts_params.id : null,
            speed: this.params.tts_params.speed ? this.params.tts_params.speed : 1,
            emotion: this.params.tts_params.emotion ? this.params.tts_params.emotion : null,
            language: this.params.tts_params.language ? this.params.tts_params.language : null,
            provider: this.params.tts_params.provider ? this.params.tts_params.provider : null,
            product_code: this.params.tts_params.product_code && this.params.tts_params.product_code !== '' ? this.params.tts_params.product_code : this.tts_params.product_code,
            variable_name: this.params.tts_params.variable_name ? this.params.tts_params.variable_name : null,
        }

        this.text = this.params.text ? this.params.text : null;

        this.intent = {
            variable: this.params.intent.variable ? this.params.intent.variable : null,
            words_equal: this.params.intent.words_equal ? this.params.intent.words_equal : [],
            words_in: this.params.intent.words_in ? this.params.intent.words_in : [],
            words_not_in: this.params.intent.words_not_in ? this.params.intent.words_not_in : [],
            action: this.params.intent.action ? this.params.intent.action : null
        }

        this.http_request_params = {
            url: this.params.http_request_params.url ? this.params.http_request_params.url : null,
            method: this.params.http_request_params.method ? this.params.http_request_params.method : null,
            header: this.params.http_request_params.header ? this.params.http_request_params.header : null,
            data: this.params.http_request_params.data ? this.params.http_request_params.data : null,
            variables: this.params.http_request_params.variables ? this.params.http_request_params.variables : null
        }

        this.condition = {
            operation: this.params.condition.operation ? this.params.condition.operation : null,
            action: this.params.condition.action ? this.params.condition.action : null
        }
        
        this.next_action   = this.params.next_action ? this.params.next_action : null;
        this.set_variables = this.params.set_variables ? this.params.set_variables : null;
    },

    methods: {

        async deleteItem(index){
            this.$parent.$parent.$parent.$parent.$parent.deleteBlock(index);
            return false;
        },

        getData(){
            if(this.attachments.size > 0){
                let attachments = [];
                this.attachments.forEach(el => {
                    attachments.push(el);
                })
                this.audio.title    = attachments[0].title;
                this.audio.filename = attachments[0].filename;
                this.audio.status   = attachments[0].status;
                this.audio.path     = attachments[0].path;
                this.audio.ext      = attachments[0].ext;
                this.audio.uuid     = attachments[0].uuid;
            } else {
                this.audio.title    = null;
                this.audio.filename = null;
                this.audio.status   = null;
                this.audio.path     = null;
                this.audio.ext      = null;
                this.audio.uuid     = null;
            }
            if(!this.audio.from_variable){
                this.audio.variable_name = null;
            }
            return {
                "id": this.id,
                "parents_id": this.parents_id,
                "description": this.description,
                "action": this.action && this.action.code ? this.action.code : null,
                "sms_send": this.sms_send,
                "audio": this.audio,
                "record": this.record,
                "stt_params": this.stt_params,
                "tts_params": this.tts_params,
                "text": this.text,
                "intent": this.intent,
                "condition": this.condition,
                "http_request_params": this.http_request_params,
                "next_action": this.next_action,
                "set_variables": this.set_variables,
            }
        }
    }
}
</script>

<template>
    <div class="list-group-item draggable" style="max-width: 900px; margin: 20px; margin-left: 0px; margin-right: 0px; border-top: 1px solid rgba(0, 0, 0, 0.125)">
        <div class="row">
            <div class="col-sm-8 col-xl-6">
                <h5 class="card-title fs-16" style="font-size: 16px">
                    <i class="uil uil-arrows-v-alt" style="margin-right: 10px"></i>ID: {{id}}
                </h5>
            </div>
            <div class="col-sm-4 col-xl-6">
                <a href="#" @click.prevent="deleteItem(index)" :id="index+'_del'" class="btn btn-light btn-sm float-sm-right">
                    <b-tooltip :target="index+'_del'" placement="top">Удалить</b-tooltip>
                    <i class="uil uil-trash-alt"></i>
                </a>
            </div>
        </div>

        <b-form-group
            label="Действие"
            :label-for="'block_' + id"
        >
            <multiselect
                :id="'block_' + id"
                :track-by="trackByAction"
                v-model="action"
                :options="actions_options"
                placeholder="Выберите из списка"
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="name"
            ></multiselect>
        </b-form-group>

        <FormAudioPlay v-if="show_audio_play" />
        <FormAudioRecord v-if="show_audio_record" />
        <FormSpeechSynthesis v-if="show_speech_synthesis" />
        <FormAudioTranscription v-if="show_audio_transcription" />
        <FormSetVariables v-if="show_set_variables" />
        <FormSMSSend v-if="show_sms_send" />
        <FormHTTPRequest v-if="show_http_request" />
        <FormCondition v-if="show_condition" />
        <FormIntent v-if="show_intent" />

        <div class="row">
            <div class="col-sm-12 col-xl-6">
                <b-form-group
                    label="Комментарий к блоку"
                    :label-for="'description_' + id"
                >
                    <b-form-input
                        :id="'description_' + id"
                        v-model="description"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-sm-12 col-xl-6">
                <b-form-group
                    label="Выполнить действие"
                    :label-for="'next_action_' + id"
                >
                    <b-form-input
                        :id="'next_action' + id"
                        placeholder="Укажите ID блока или оставьте пустым"
                        v-model="next_action"
                    ></b-form-input>
                </b-form-group>
            </div>
        </div>

    </div>
</template>

<style>
    .draggable h5 {
        cursor: grab;
    }
</style>